import React from "react"

const QuestionAndAnswer = ({ question, answer }) => {
  return (
    <div className="flex flex-col items-start flex-1 mb-5 lg:mb-10">
      <p className="mb-4 text-xl text-k2Black lg:text-[2rem] font-semibold">
        {question}
      </p>
      {typeof question === "string" ? (
        <p className="text-lg leading-8 lg:leading-10 lg:text-2xl text-kGray">
          {answer}
        </p>
      ) : (
        answer
      )}
    </div>
  )
}

export default QuestionAndAnswer
